import { render } from "./PageTabs.vue?vue&type=template&id=e91afe16"
import script from "./PageTabs.vue?vue&type=script&lang=js"
export * from "./PageTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__